// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2MiGs","productName":"Table_productName__22Zaz"};